import React from 'react';
import { roadMapData } from '../../data/disclosureRequest';
import type { Density, RoadMapSection } from '../../types/disclosure';
import { SectionCard } from './SectionCard';
import { FieldGroupBlock } from './FieldGroupBlock';
import { NotApplicableGroups } from './NotApplicableGroups';
import { NotesPanel } from './NotesPanel';
interface RoadMapTabProps {
  density: Density;
  showApiNames: boolean;
}
export function RoadMapTab({
  density,
  showApiNames
}: RoadMapTabProps) {
  const {
    sections,
    notesSection
  } = roadMapData;
  const renderSection = (section: RoadMapSection, columns: 1 | 2 | 3) => {
    const applicable = section.groups.filter(group => group.applicable !== false);
    const notApplicable = section.groups.filter(group => group.applicable === false);
    return <SectionCard key={section.id} id={section.id} number={section.number} title={section.title} description={section.description} data-id="element-53" data-mp="34v7css9w25l3">
        {applicable.map(group => <FieldGroupBlock key={group.id} group={group} density={density} showApiNames={showApiNames} columns={columns} data-id="element-54" data-mp="2gm40rcjkk1jz" />)}
        <NotApplicableGroups groups={notApplicable} sectionId={section.id} data-id="element-55" data-mp="2qc6ujeyiljjd" />
      </SectionCard>;
  };
  return <main className="min-h-full w-full bg-slate-100 px-4 py-5 sm:px-6" data-id="element-56" data-mp="2ubfq8pd47rhk">
      <div className="mx-auto max-w-[1280px] space-y-4" data-id="element-57" data-mp="1xn8b8einobch">
        <SectionCard id={notesSection.id} number={notesSection.number} title={notesSection.title} description={notesSection.description} data-id="element-58" data-mp="1xot501x5bq9a">
          <NotesPanel notes={notesSection.notes} showApiNames={showApiNames} data-id="element-59" data-mp="26p96j5ubwnbi" />
        </SectionCard>

        {sections.map(section => renderSection(section, 2))}
      </div>
    </main>;
}